module.exports = __webpack_public_path__ + "static/img/cover.f9d65a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/work4/cover.png
// module id = mDq8
// module chunks = 0